module.exports = __webpack_public_path__ + "media/images/riders/MONIKA_HRASTNIK-43e224e56b17eb44f6d099f9d8bf2932.png";